<div>
    <app-header></app-header>
</div>

<div class="container-fluid mt-3" *ngIf="stoken">
    <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="productimgBox">
                <img *ngIf="images" [src]="selectedImage?.url" [alt]="productData?.title || 'Product'"
                    class="product-main-img" />
                <div class="d-flex  custom-sub-main" *ngIf="images">
                    <img *ngFor="let img of images" [src]="img.url" [alt]="productData?.title || 'Product'"
                        (click)="onImageClick(img)" class="product-sub-main-img" />
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="productDetail pe-3">
                <!-- <div class="catname-head">
                    <span class="catname"> Tools & Accessories</span>
                </div> -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <h2 class="producttitle">{{ productData?.Category3?.title }} </h2>
                    </div>
                    <!-- <div class="col-md-2 d-flow p-2">
                        <img src="assets/images/new_img/Star.svg"><span class="rating"> (4.2)</span>
                    </div> -->
                </div>
                <p class="mt-2 mb-0">Offered by: <a style="cursor: pointer;" (click)="navigatOnProfile()"
                        class="text-g">{{productData?.Auth?.UserAuths[0]?.company_name || 'Null'}}
                        <span *ngIf="stateDetails">,{{
                            productData.stateDetails?.name }},{{
                            productData.cityDetails?.city }}</span>
                    </a>
                    <span class="successbox"><img src="assets/images/new_img/success.svg" class="" alt="">Trusted
                        Partner </span>
                </p>
                <p class="mt-2 mb-0"> <span>Available Stock:</span> <span class="text-g">
                        {{productData?.inventory || 'N/A'}}/{{productData?.iunit}}</span></p>
                <p class="mt-2 mb-0"><span>Price:</span> <span class="text-g"> {{ productData?.price || 'Ask for
                        Price'}}</span> </p>
                <p class="mb-0 mt-2 "> <span>GST Number:</span> <span class="text-g">{{
                        productData?.Auth?.UserAuths[0]?.gst_no || 'N/A'}}</span></p>
                <div class="row mt-3 mb-3">
                    <div class="qty-div col-md-3 col-sm-12 col-xs-12 ">
                        <input type="text" placeholder="Qty (Enter Here)" class="form-control qty-text">
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12  col-sm-12 col-xs-12 d-flex py-1 align-items-center">
                        <input type="checkbox"><span class="ms-2 loan-text"> Loan required</span>
                    </div>
                </div>

                <div class="productBtn d-flex justify-content-between mt-2 mb-3 row">
                    <div class="col-xl-6 col-md-12  col-sm-12 col-xs-12">
                        <button (click)="toggleWishlist()" class="productbtnborder">
                            <img [src]="isInWishlist ? 'assets/images/new_img/heartfull.png' : 'assets/images/new_img/heart.svg'"
                                alt="">
                            <span class="ms-2">{{ isInWishlist == true ? 'Remove from Wishlist' : 'Add to Wishlist'
                                }}</span>
                        </button>
                    </div>
                    <div class="col-md-12 col-xl-6 col-sm-12 col-xs-12">
                        <button (click)="toggleGetQuote()" class="productDetailbg">
                            <span>
                                Get a Quote
                            </span>
                            <!-- <span>{{ isGetQuote ? 'Remove from Quote' : 'Get a Quote' }}</span> -->
                        </button>
                    </div>
                </div>

                <div class="divider mt-3 mb-4"> </div>
                <div class="tags d-flex row">
                    <div class="col-md-12 high-text  col-sm-12 col-xs-12">
                        <h3 class="pheadsub"> Highlights</h3>
                    </div>
                    <!-- {{productData | json}} -->
                    <div class="row">
                        <div class="data col-md-6  col-sm-12 col-xs-12" *ngIf="productData?.cutting_speed">
                            <div class="custom-card me-2 mb-1">
                                <div class="center-div">
                                    <span class="m-0 type ">Cutting Speed</span><br>
                                    <span id="below" class="m-0 value">{{productData?.cutting_speed }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="data col-md-6  col-sm-12 col-xs-12" *ngIf="productData?.surface_finish">
                            <div class="custom-card mb-1">
                                <div class="center-div">
                                    <span class="m-0 type">Surface Finish</span><br>
                                    <span id="below" class="m-0 value"> {{productData?.surface_finish }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="data col-md-6  col-sm-12 col-xs-12" *ngIf="productData?.distance_highway">
                            <div class="custom-card me-2">
                                <div class="center-div">
                                    <span class="m-0 type">Dimensions</span><br>
                                    <span id="below" class="m-0 value"> {{productData?.distance_highway }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="data col-md-6  col-sm-12 col-xs-12" *ngIf="productData?.lead_time">
                            <div class="custom-card">
                                <div class="center-div">
                                    <span class="m-0 type">Tool Life</span><br>
                                    <span id="below" class="m-0 value">{{productData?.lead_time }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider my-4"> </div>
                <div class="productOffers mt-3" *ngIf="productData?.offer_details">
                    <div class="high-text">
                        <p class="pheadsub"> Offers</p>
                    </div>
                    <h5><img src="assets/images/new_img/offertick.svg" class="" alt="" />
                        {{productData?.offer_details}}
                    </h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 overview-h pe-5 ps-5  col-sm-12 col-xs-12">
            <h4 class="text-center mt-4 o-heading"> Overview</h4>
            <div class="p-2">
                <h5 class="deschead" *ngIf="productData?.description"> Product Description</h5>
                <ul class="descdesc" *ngIf="productData?.description">
                    <li>{{productData?.description}}</li>
                </ul>
                <h5 class="deschead" *ngIf="productData?.highlights"> Specifications</h5>
                <p class="deschead" *ngIf="productData?.highlights">{{productData?.highlights}}</p>
            </div>
        </div>
        <div class="col-md-12 overview-h pe-5 ps-5  col-sm-12 col-xs-12">
            <ul class="productinfo p-0">
                <li *ngIf="productData?.Industry?.industry_name"> <span> Offering</span> <span>
                        {{productData?.Industry?.industry_name || 'N/A'}}</span> </li>
                <li *ngIf="productData?.Category1?.title"> <span> Industry</span> <span> {{productData?.Category1?.title
                        || 'N/A'}}</span> </li>
                <li *ngIf="productData?.Category2?.title"> <span> Category</span> <span> {{productData?.Category2?.title
                        || 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.Category3?.title"> <span> Sub Category</span> <span>
                        {{productData?.Category3?.title || 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.Brand?.brand_name !='null'"> <span> Brand name</span> <span>
                        {{productData?.Brand?.brand_name || 'N/A'}}</span> </li>
                <li *ngIf="productData?.model_number !='null'"> <span> Feed Rate </span> <span>
                        {{productData?.model_number || 'N/A'}}</span> </li>
                <li *ngIf="productData?.tolerance !='null'"> <span> Tolerance</span> <span> {{productData?.tolerance ||
                        'N/A'}}</span> </li>
                <li *ngIf="productData?.cooling_requirements !='null'"> <span> Cooling Requirement</span> <span>
                        {{productData?.cooling_requirements || 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.tool_life !='null'"> <span> Tool Life</span> <span> {{productData?.tool_life ||
                        'N/A'}}</span> </li>
                <li *ngIf="productData?.resharpening_capability !='null'"> <span> Re-sharpening Capability</span> <span>
                        {{productData?.resharpening_capability ||
                        'N/A'}}</span> </li>
                <li *ngIf="productData?.insert_capability !='null'"> <span> Insert Compatibility</span> <span>
                        {{productData?.insert_capability || 'N/A'}}</span> </li>
                <li *ngIf="productData?.select_packaging !='null'"> <span> Packaging</span> <span>
                        {{productData?.select_packaging || 'N/A'}}</span> </li>
                <li *ngIf="productData?.minimum_quantity_required !='null'"> <span> Minimum Order Quantity</span> <span>
                        {{productData?.minimum_quantity_required ||
                        'N/A'}}</span> </li>
                <li *ngIf="productData?.safety_stock !='null'"> <span> Safety Stock</span> <span>
                        {{productData?.safety_stock || 'N/A'}}</span> </li>
                <li *ngIf="productData?.shipping_terms !='null'"> <span> Logistics</span> <span>
                        {{productData?.shipping_terms || 'N/A'}}</span> </li>
                <li *ngIf="productData?.regulatory_compliance !='null'"> <span> Regulatory Compliance</span> <span>
                        {{productData?.regulatory_compliance|| 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.warranty_period !='null'"> <span> Warranty</span> <span>
                        {{productData?.warranty_period|| 'N/A'}}</span> </li>
                <li *ngIf="productData?.AMC !='null'"> <span> Annual Maintenance Contract (AMC)</span> <span>
                        {{productData?.AMC
                        || 'N/A'}}</span> </li>
                <li *ngIf="productData?.SLA !='null'"> <span> Service Level Agreement (SLA)</span> <span>
                        {{productData?.SLA ||
                        'N/A'}}</span> </li>
            </ul>
        </div>
    </div>
</div>
<div class="container-fluid mt-5 px-3" *ngIf="stoken">
    <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="moreFromSeller?.length !== 0">
        <div class="align-items-center row">
            <span class="mb-0 title-pp text-center mb-4">More from the Seller</span>

            <!-- Loop through moreFromSeller array -->
            <div class="col-md-3 mb-4" *ngFor="let prod of moreFromSeller">
                <!-- New box with styling -->
                <div class="normalbox">
                    <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
                        <span class="newtick">Top Seller</span>
                        <div class="normalboximg" *ngIf="prod">
                            <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url"
                                class="img-fluid normalimg" alt="{{ prod.title }}" />
                        </div>
                        <div class="normalboxDetail">
                            <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div> -->
                            <h5>{{ prod.Category3?.title }}</h5>
                            <p class="location d-flex align-items-center">
                                <span *ngIf="prod.cityDetails?.city"><img src="assets/images/locations.svg"
                                        class="img-fluid me-2" alt="location"></span>
                                <span *ngIf="prod.cityDetails?.city">{{
                                    prod.cityDetails?.city }},{{
                                    prod.stateDetails?.name }}</span>
                            </p>
                            <div class="price">Price <span>₹{{ prod?.price }}</span><span
                                    *ngIf="prod?.punit">/{{prod?.punit ||
                                    ''}}</span></div>
                            <div class="ContactSeller mt-2">
                                <a href=""> Contact the Seller</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweall">
                <button class="btn viewall" (click)="viewAllProductsFromSeller('moreFromSeller')">View All</button>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweless">
                <button class="btn viewall" (click)="viewLessProductsFromSeller('lessFromSeller')">View Less</button>
            </div>

        </div>
    </div>

</div>
<div class="container-fluid mt-3 px-4" *ngIf="stoken">
    <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="relatedProducts?.length !== 0">
        <div class="align-items-center row">
            <span class="mb-0 title-pp text-center mb-4">Related Products</span>
            <div class="col-md-3 mb-4" *ngFor="let prod of relatedProducts">
                <div class="normalbox">
                    <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
                        <span class="newtick">Top Seller</span>
                        <div class="normalboximg" *ngIf="prod">
                            <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url"
                                class="img-fluid normalimg" alt="{{ prod.title }}" />
                        </div>
                        <div class="normalboxDetail">
                            <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div> -->
                            <h5>{{ prod.Category3?.title }} </h5>
                            <p class="location d-flex align-items-center">
                                <span *ngIf="prod.cityDetails?.city"><img src="assets/images/locations.svg"
                                        class="img-fluid me-2" alt="location"></span>
                                <span *ngIf="prod.cityDetails?.city">{{
                                    prod.cityDetails?.city }},{{
                                    prod.stateDetails?.name }}</span>
                                <!-- <span> {{ prod.location }}</span> -->
                            </p>
                            <div class="price">Price <span>₹{{ prod?.price }}</span><span
                                    *ngIf="prod?.punit">/{{prod?.punit ||
                                    ''}}</span></div>
                            <div class="ContactSeller mt-2">
                                <a href=""> Contact the Seller</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweallrel">
                <button class="btn viewall" (click)="viewAllProductsFromRelated('relatedProducts')">View All</button>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viwelessrel">
                <button class="btn viewall" (click)="viewLessProductsFromRelated('lessrelatedProducts')">View
                    Less</button>
            </div>
        </div>
    </div>
</div>


<div *ngIf="stoken">
    <app-footer></app-footer>
</div>